export default __webpack_public_path__ + "static/media/QSGs-Icon.bc65a412.png";